import {QueryKeys} from '../../../queryDefaults/QueryKeys';
import {useMutation, useQueryClient} from '@tanstack/react-query';
import {AppMedError} from '../../../error/AppMedError.ts';
import {IPatientInvitations, PatientInvitations} from '../PatientInvitations.ts';
import {PatientInvitationsApi} from '../../../apis/PatientInvitationsApi/PatientInvitationsApi.ts';

export function usePostPatientInvitations() {
    const queryClient = useQueryClient();

    return useMutation<IPatientInvitations, AppMedError, PatientInvitations>({
        mutationKey: [QueryKeys.patientInvitations, 'create'],
        mutationFn: async (variables: IPatientInvitations) => {
            const result = await PatientInvitationsApi.postPatientInvitations(variables);
            return new PatientInvitations(result);
        },
        onSuccess: async (data: IPatientInvitations) => {
            queryClient.setQueryData<PatientInvitations>([QueryKeys.patientInvitations], (prev) => {
                console.log(data);
                return prev;
            });
        },
    });
}